// extracted by mini-css-extract-plugin
module.exports = {"Banner1":"Banner1_Banner1__LK_tF"};